import React from "react";
import Accordion from "react-bootstrap/Accordion";
import {
  convertTo12HourFormat,
  formatDateTime,
} from "../../../common-data/Converts";
import PaginationModified from "../../../../data/PaginationModified";
import "../../../../styles/hydiene-system/hygiene-mobile.css";
import {
  CheckCircleIcon,
  CrossCircleIcon,
} from "../../../../images/icons/icons";

const FrequenecyTasksMobile = ({
  tableData,
  tablePagination,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  selectedTab,
  setModValues,
  isAdmin,
}) => {
  const [openIndex, setOpenIndex] = React.useState(null);

  function getPagination() {
    try {
      const pagination = tablePagination ? tablePagination : [];
      return pagination;
    } catch (error) {
      console.log(error);
    }
  }

  const getStatusProps = (status) => {
    switch ((status || "").toLowerCase()) {
      case "missed":
        return {
          color: "#e74c3c",
          icon: (
            <svg
              width="18"
              height="18"
              fill="none"
              viewBox="0 0 24 24"
              style={{ marginRight: 6 }}
            >
              <circle cx="12" cy="12" r="12" fill="#fdeaea" />
              <path
                d="M8 8l8 8M16 8l-8 8"
                stroke="#e74c3c"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          ),
        };
      case "pending":
        return {
          color: "#F4631E",
          icon: (
            <svg
              width="18"
              height="18"
              fill="none"
              viewBox="0 0 24 24"
              style={{ marginRight: 6 }}
            >
              <circle cx="12" cy="12" r="12" fill="#FFF3EC" />
              <path
                d="M12 6v6l4 2"
                stroke="#F4631E"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          ),
        };
      case "completed":
        return {
          color: "#27ae60",
          icon: (
            <svg
              width="18"
              height="18"
              fill="none"
              viewBox="0 0 24 24"
              style={{ marginRight: 6 }}
            >
              <circle cx="12" cy="12" r="12" fill="#eafaf1" />
              <path
                d="M7 13l3 3 7-7"
                stroke="#27ae60"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          ),
        };
      default:
        return {
          color: "#bdbdbd",
          icon: (
            <svg
              width="18"
              height="18"
              fill="none"
              viewBox="0 0 24 24"
              style={{ marginRight: 6 }}
            >
              <circle cx="12" cy="12" r="12" fill="#f5f5f5" />
              <path
                d="M12 8v4"
                stroke="#bdbdbd"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <circle cx="12" cy="16" r="1" fill="#bdbdbd" />
            </svg>
          ),
        };
    }
  };

  return (
    <div className="all-leads-log">
      {tableData?.length > 0 &&
        tableData.map((row, index) => {
          const isDisable =
            row?.status !== "pending" &&
            selectedTab !== "rejected" &&
            selectedTab !== "all_rejected";
          // const isDisableVerify =
          //   (row?.status !== "completed" || selectedTab !== "re_submitted") &&
          //   row?.approval_status !== 0;
          const isEnabledVerify =
            (row?.status === "completed" || selectedTab === "re_submitted") &&
            row?.approval_status === 0;
          const isApproved = row?.approval_status === 1;
          const isApprovalPending = row?.approval_status === 0;

          const taskPriroty = row?.priority || "";
          const priorityColor =
            taskPriroty === "critical"
              ? "#dc3545"
              : taskPriroty === "high"
              ? "#ffc107"
              : taskPriroty === "medium"
              ? "#0d6efd"
              : "#198754";
          const priorityTag =
            taskPriroty === "critical"
              ? "P1"
              : taskPriroty === "high"
              ? "P2"
              : taskPriroty === "medium"
              ? "P3"
              : "P4";

          const imgArrayLength =
            Number(row?.images_arr?.length || 0) > 0 &&
            Number(row?.img_quantity || 0) > 0;
          const vdoArrayLength =
            Number(row?.video_arr?.length || 0) > 0 &&
            Number(row?.vid_quantity || 0) > 0;

          const statusProps = getStatusProps(row?.status);

          return (
            <div className="hui-mobile-card" key={index}>
              <div className="hui-mobile-card-header">
                <span className="hui-mobile-card-title">
                  {row?.category_name || "-"}
                </span>
                <button
                  type="button"
                  className="hui-mobile-update-btn"
                  disabled={isDisable}
                  onClick={() =>
                    !isDisable &&
                    setModValues((prevs) => ({
                      ...prevs,
                      isModOpen: true,
                      cardName: "update",
                      rowData: row,
                    }))
                  }
                >
                  <svg
                    width="18"
                    height="18"
                    fill="none"
                    viewBox="0 0 24 24"
                    style={{ marginRight: 8, verticalAlign: "middle" }}
                  >
                    <path
                      d="M4 20h4.586a1 1 0 0 0 .707-.293l9.414-9.414a2 2 0 0 0 0-2.828l-2.172-2.172a2 2 0 0 0-2.828 0L4.293 14.586A1 1 0 0 0 4 15.293V20z"
                      stroke="#fff"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M14.828 6.828l2.344 2.344"
                      stroke="#fff"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  Update Task
                </button>
              </div>

              <div className="hui-mobile-info-row">
                <span className="hui-mobile-info-label">Task Name</span>
                <span className="hui-mobile-info-value">
                  {row?.task_name || "NA"}
                </span>
              </div>
              <div className="hui-mobile-info-row">
                <span className="hui-mobile-info-label">Task Status</span>
                <span
                  className="hui-mobile-info-value"
                  style={{
                    color: statusProps.color,
                    display: "flex",
                    alignItems: "center",
                    fontWeight: 700,
                  }}
                >
                  {statusProps.icon}
                  {row?.status?.replace(/_/g, " ") || "NA"}
                </span>
              </div>
              <div className="hui-mobile-info-row">
                <span className="hui-mobile-info-label">Start/End Time</span>
                <span className="hui-mobile-info-value">
                  {row?.start_time
                    ? convertTo12HourFormat(row.start_time)
                    : "-"}{" "}
                  - {row?.end_time ? convertTo12HourFormat(row.end_time) : "-"}
                </span>
              </div>

              {openIndex === index && (
                <div className="hui-mobile-more-content">
                  <div className="hui-mobile-info-row flex-row-between">
                    <span className="hui-mobile-info-label">
                      <svg
                        width="16"
                        height="16"
                        fill="none"
                        viewBox="0 0 24 24"
                        style={{ marginRight: 6, verticalAlign: "middle" }}
                      >
                        <circle cx="12" cy="12" r="12" fill="#f3f6ff" />
                        <text x="8" y="17" fontSize="10" fill="#2d3be7">
                          {priorityTag}
                        </text>
                      </svg>
                      Priority
                    </span>
                    <span className="hui-mobile-info-value">
                      {row?.priority || "NA"}
                    </span>
                  </div>

                  <div className="hui-mobile-info-row flex-row-between">
                    <span className="hui-mobile-info-label">
                      <svg
                        width="16"
                        height="16"
                        fill="none"
                        viewBox="0 0 24 24"
                        style={{ marginRight: 6, verticalAlign: "middle" }}
                      >
                        <circle cx="12" cy="12" r="12" fill="#eafaf1" />
                        <path
                          d="M7 13l3 3 7-7"
                          stroke="#27ae60"
                          strokeWidth="2"
                          strokeLinecap="round"
                        />
                      </svg>
                      Media Required
                    </span>
                    <span className="hui-mobile-info-value icon">
                      {row?.media_required ? "Yes" : "No"}
                    </span>
                  </div>

                  <div className="hui-mobile-info-row flex-row-between">
                    <span className="hui-mobile-info-label">images</span>
                    <span
                      className={`hui-mobile-info-value ${
                        imgArrayLength ? "link" : ""
                      }`}
                      onClick={() =>
                        imgArrayLength &&
                        setModValues((prevs) => ({
                          ...prevs,
                          isModOpen: true,
                          cardName: "images",
                          rowData: row,
                        }))
                      }
                    >
                      {row?.img_quantity || 0}
                    </span>
                  </div>

                  <div className="hui-mobile-info-row flex-row-between">
                    <span className="hui-mobile-info-label">videos</span>
                    <span
                      className={`hui-mobile-info-value ${
                        vdoArrayLength ? "link" : ""
                      }`}
                      onClick={() =>
                        vdoArrayLength &&
                        setModValues((prevs) => ({
                          ...prevs,
                          isModOpen: true,
                          cardName: "videos",
                          rowData: row,
                        }))
                      }
                    >
                      {row?.vid_quantity || 0}
                    </span>
                  </div>
                  <div className="hui-mobile-info-row flex-row-between">
                    <span className="hui-mobile-info-label">Create Ticket</span>
                    <span className="hui-mobile-info-value icon-value">
                      {row?.add_gym_req ? (
                        <CheckCircleIcon />
                      ) : (
                        <CrossCircleIcon />
                      )}
                    </span>
                  </div>

                  <div
                    className={`hui-mobile-info-row ${
                      row?.description ? "" : "flex-row-between"
                    }`}
                  >
                    <span className="hui-mobile-info-label">
                      task description
                    </span>
                    <span className="hui-mobile-info-value multi-value">
                      {row?.description || "NA"}
                    </span>
                  </div>

                  {(selectedTab === "all" || selectedTab === "completed") && (
                    <div className="hui-mobile-info-row flex-row-between">
                      <span className="hui-mobile-info-label">
                        approval status
                      </span>
                      <span className="hui-mobile-info-value multi-value icon-value">
                        {row?.approval_status === 1 ? (
                          <CheckCircleIcon />
                        ) : row?.approval_status === 2 ? (
                          <CrossCircleIcon />
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-hourglass-top"
                            viewBox="0 0 16 16"
                            style={{ color: "#EB5B00" }}
                          >
                            <path d="M2 14.5a.5.5 0 0 0 .5.5h11a.5.5 0 1 0 0-1h-1v-1a4.5 4.5 0 0 0-2.557-4.06c-.29-.139-.443-.377-.443-.59v-.7c0-.213.154-.451.443-.59A4.5 4.5 0 0 0 12.5 3V2h1a.5.5 0 0 0 0-1h-11a.5.5 0 0 0 0 1h1v1a4.5 4.5 0 0 0 2.557 4.06c.29.139.443.377.443.59v.7c0 .213-.154.451-.443.59A4.5 4.5 0 0 0 3.5 13v1h-1a.5.5 0 0 0-.5.5m2.5-.5v-1a3.5 3.5 0 0 1 1.989-3.158c.533-.256 1.011-.79 1.011-1.491v-.702s.18.101.5.101.5-.1.5-.1v.7c0 .701.478 1.236 1.011 1.492A3.5 3.5 0 0 1 11.5 13v1z" />
                          </svg>
                        )}
                      </span>
                    </div>
                  )}

                  {(selectedTab === "all" ||
                    selectedTab === "completed" ||
                    selectedTab === "approved" ||
                    selectedTab === "rejected" ||
                    selectedTab === "all_rejected" ||
                    selectedTab === "re_submitted") && (
                    <>
                      <div className="hui-mobile-info-row">
                        <span className="hui-mobile-info-label">
                          submitted by
                        </span>
                        <span className="hui-mobile-info-value multi-value">
                          {row?.submitted_by_name || "NA"}
                          <br />
                          <small className="lowercase underline">
                            {row?.submitted_by_mobile || ""}
                            <br />
                            {row?.submitted_by_email || ""}
                          </small>
                        </span>
                      </div>

                      {!isApprovalPending && (
                        <>
                          <div className="hui-mobile-info-row">
                            <span className="hui-mobile-info-label">
                              {isApproved ? "approved" : "rejected"} date
                            </span>
                            <span className="hui-mobile-info-value multi-value">
                              {row?.aprv_rej_date
                                ? formatDateTime(row.aprv_rej_date)
                                : "-"}
                            </span>
                          </div>

                          <div className="hui-mobile-info-row">
                            <span className="hui-mobile-info-label">
                              {isApproved ? "approved" : "rejected"} by
                            </span>
                            <span className="hui-mobile-info-value multi-value">
                              {row?.aprv_rej_by_name || "NA"}
                              <br />
                              <small className="lowercase underline">
                                {row?.aprv_rej_by_mobile || ""}
                                <br />
                                {row?.aprv_rej_by_email || ""}
                              </small>
                            </span>
                          </div>

                          <div className="hui-mobile-info-row">
                            <span className="hui-mobile-info-label">
                              {isApproved ? "approved" : "rejected"} remarks
                            </span>
                            <span className="hui-mobile-info-value multi-value">
                              {row?.aprv_rej_remarks || "NA"}
                            </span>
                          </div>
                        </>
                      )}
                    </>
                  )}
                </div>
              )}

              <button
                type="button"
                className="hui-mobile-view-more-btn"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className="hui-mobile-view-more-btn-text">
                  {openIndex === index ? "View Less" : "View More"}
                </span>
                <svg
                  width="18"
                  height="18"
                  fill="none"
                  viewBox="0 0 24 24"
                  style={{
                    marginLeft: 8,
                    transition: "transform 0.2s",
                    transform:
                      openIndex === index ? "rotate(180deg)" : "rotate(0deg)",
                  }}
                >
                  <path
                    d="M7 10l5 5 5-5"
                    stroke="#fff"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>
          );
        })}

      <div className="lead-logs-card-pagination">
        <PaginationModified
          isPage={isPage}
          onChangePage={setIsPage}
          pagination={getPagination()}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
        />
      </div>
    </div>
  );
};

export default FrequenecyTasksMobile;
